<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

const reload = () => {
  window.location.reload();
};
</script>

<template>
  <div
    class="flex flex-col items-center justify-center w-full h-full gap-4 p-8 text-center"
  >
    <span class="i-lucide-cloud-off size-12 text-n-slate-10" />
    <div class="flex flex-col gap-1">
      <h2 class="text-xl font-medium text-n-slate-12">
        {{ $t('NETWORK.CONNECTION_LOST.TITLE') }}
      </h2>
      <p class="max-w-md text-sm text-n-slate-11">
        {{ $t('NETWORK.CONNECTION_LOST.DESCRIPTION') }}
      </p>
    </div>
    <Button
      :label="$t('NETWORK.CONNECTION_LOST.RETRY')"
      icon="i-lucide-refresh-ccw"
      @click="reload"
    />
  </div>
</template>
